import { render } from "./OrganisationUserAdmin.vue?vue&type=template&id=16c60f9e"
import script from "./OrganisationUserAdmin.vue?vue&type=script&lang=js"
export * from "./OrganisationUserAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__